var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AvatarVsAvatar"},[_c('div',{staticClass:"Avatar",style:({ backgroundImage: ("url(" + (_vm.me.avatar) + ")") })}),_c('div',{staticClass:"Avatar"}),_c('div',{staticClass:"vs"},[_vm._v("\n        Vs\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }